import React from 'react'

import styled, { useTheme } from 'styled-components';
import Button from '../../common/Button';

// layout
import { Flex } from '../../styleguide/layout'
import { H3, Span } from '../../styleguide/typography';
import { Img } from './LowTransaction';

import wallet from "../../../assets/wallet.png"
import arrowLeftTop from "../../../assets/arrow-left-top.png"

const Wallet = ({ primary }) => {

  const theme = useTheme();

  return (
    <Flex
        width="100%" 
        margin="5rem 0" 
        borderRadius="1rem" 
        bg={primary ? theme.colors.primary : theme.colors.lighterGray} 
        minh="480px" 
        padding="2.5rem 6rem 0 8.75rem"
        gap="4.5rem" 
        position="relative"
        directionMobile="column"
        paddingMobile="2.5rem 2.5rem 0 2.5rem"
    >

			<Flex 
				width="100%" 
				direction="column" 
				gap="1.4rem" 
				margin="7.25rem 0 0 0" 
				marginMobile="0"
				itemsMobile="center"
			>
				<H3 
					maxWidth="400px" 
					color={primary ? theme.colors.white : theme.colors.primary} 
					alignMobile="center" 
					width="100%"
				>
					More Than Just A <span style={{ color: theme.colors.secondary }}> Wallet </span>
				</H3>
				<Span color={primary ? theme.colors.white : theme.colors.primary} alignMobile="center" maxWidth="430px">
					Express yourself in each payment. The Mula wallet allows you easily 
					connect with the people you love. Easily send money to your 
					loved one just as you chat with them.
				</Span>

				<Button variant={primary ? "" : "primary"} noIcon to="" text="DOWNLOAD WALLET" />
			</Flex>

			<Flex items="flex-end">
				<Img src={wallet} alt="wallet" />
			</Flex>

			<PosImage src={arrowLeftTop} alt="arrow" />
    </Flex>
  )
}

export default Wallet

const PosImage = styled.img`
	position: absolute;
	bottom: 3rem;
	left: 37rem;
	width: 10rem;
	height: auto;

	@media (max-width: 768px) {
		display: none;
	}
`